import React from 'react';

export function CapodannoIncludedEditor({ packages, onChange }) {
  const pkgs = packages.filter(p => (p.type || '').startsWith('capodanno_'));
  if (!pkgs.length) return null;
  return (
    <div className="rounded-xl p-4 space-y-3" data-testid="capodanno-included-editor"
      style={{ background: 'rgba(251,191,36,0.05)', border: '1px solid rgba(251,191,36,0.35)' }}>
      <span className="font-manrope font-700 text-sm" style={{ color: '#fbbf24' }}>✦ Cosa è compreso (una voce per riga)</span>
      {pkgs.map(p => (
        <div key={p.type}>
          <label className="block text-xs font-manrope font-600 text-gray-400 mb-1">{p.icon} {p.label} — € {p.price}</label>
          <textarea
            rows={3}
            value={(p.included || []).join('\n')}
            onChange={e => onChange(p.type, e.target.value.split('\n'))}
            placeholder="Es. una voce per riga"
            data-testid={`included-editor-${p.type}`}
            className="input-elegant text-sm w-full"
            style={{ minHeight: '72px', resize: 'vertical' }}
          />
        </div>
      ))}
    </div>
  );
}
